export default __webpack_public_path__ + "static/media/stock.e7500263.svg";